import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/* eslint-disable no-shadow */
import Vue from 'vue';
import Vuex from 'vuex';
import MagicService from '@/service/magic';
import TicketService from '@/service/ticket';
import { now } from '@vip-activity/business';
import config from '@/config';
Vue.use(Vuex);
var state = {
  hasZhiboTicket: undefined,
  hasDianboTicket: undefined,
  ticketReady: false,
  hasBook: undefined,
  buyList: undefined,
  orderState: -1,
  inviteUserInfo: undefined,
  inviteOrderInfo: undefined,
  receiveInfo: {},
  orderInfo: {},
  now: Date.now(),
  ticketInfo: undefined
};
var mutations = {
  saveUserInfo: function saveUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  savePayVip: function savePayVip(state, payVip) {
    state.payVip = payVip;
  },
  setState: function setState(state, payload) {
    state[payload.state] = payload.value;
  }
};
var actions = {
  hasBookAct: function hasBookAct(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, val, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              val = null;
              _context.prev = 2;
              _context.next = 5;
              return MagicService.hasBookAct();

            case 5:
              res = _context.sent;

              if (res.data.is_book) {
                val = true;
              } else {
                val = false;
              }

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);

            case 12:
              commit('setState', {
                state: 'hasBook',
                value: val
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    }))();
  },
  getBuyList: function getBuyList(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              _context2.prev = 1;
              _context2.next = 4;
              return TicketService.getBuyList();

            case 4:
              res = _context2.sent;
              commit('setState', {
                state: 'buyList',
                value: res.list || []
              });
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              commit('setState', {
                state: 'buyList',
                value: null
              });

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    }))();
  },
  getOrderState: function getOrderState(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;

              if (!(!config.orderid || !config.inviteVuid)) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              _context3.prev = 3;
              _context3.next = 6;
              return TicketService.getOrderState(config.orderid);

            case 6:
              res = _context3.sent;
              commit('setState', {
                state: 'orderState',
                value: res.data.state
              });
              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](3);
              console.error(_context3.t0);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 10]]);
    }))();
  },
  getInviteUserInfo: function getInviteUserInfo(_ref4) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;

              if (!(!config.orderid || !config.inviteVuid)) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              _context4.prev = 3;
              _context4.next = 6;
              return TicketService.getInviteUserInfo(config.orderid, config.inviteVuid);

            case 6:
              res = _context4.sent;
              commit('setState', {
                state: 'inviteUserInfo',
                value: res.master_info
              });
              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](3);
              console.error(_context4.t0);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 10]]);
    }))();
  },
  getInviteOrderInfo: function getInviteOrderInfo(_ref5) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref5.commit;

              if (!(!config.orderid || !config.inviteVuid)) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return");

            case 3:
              _context5.prev = 3;
              _context5.next = 6;
              return TicketService.getOrderInfo(config.orderid);

            case 6:
              res = _context5.sent;
              commit('setState', {
                state: 'inviteOrderInfo',
                value: res.order
              });
              _context5.next = 13;
              break;

            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](3);
              console.error(_context5.t0);

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[3, 10]]);
    }))();
  },
  getHasZhiboTicket: function getHasZhiboTicket(_ref6) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var commit, dispatch, val, res;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref6.commit, dispatch = _ref6.dispatch;
              val = null;
              _context6.prev = 2;
              _context6.next = 5;
              return TicketService.getHasZhiboTicket();

            case 5:
              res = _context6.sent;
              val = res.payStatus !== 0;

              if (val) {
                dispatch('getTicketInfo');
              }

              _context6.next = 13;
              break;

            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](2);
              console.error(_context6.t0);

            case 13:
              commit('setState', {
                state: 'hasZhiboTicket',
                value: val
              });

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[2, 10]]);
    }))();
  },
  getHasDianboTicket: function getHasDianboTicket(_ref7) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var commit, dispatch, val, res;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref7.commit, dispatch = _ref7.dispatch;
              val = null;
              _context7.prev = 2;
              _context7.next = 5;
              return TicketService.getHasDianboTicket();

            case 5:
              res = _context7.sent;
              val = !!res.cidBuyCheck; // 已购买点播

              if (val) {
                dispatch('getTicketInfo');
              }

              _context7.next = 13;
              break;

            case 10:
              _context7.prev = 10;
              _context7.t0 = _context7["catch"](2);
              console.error(_context7.t0);

            case 13:
              commit('setState', {
                state: 'hasDianboTicket',
                value: val
              });
              commit('setState', {
                state: 'ticketReady',
                value: true
              });

            case 15:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[2, 10]]);
    }))();
  },
  getOrderReceiveList: function getOrderReceiveList(_ref8, orderid) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              commit = _ref8.commit;
              _context8.prev = 1;
              _context8.next = 4;
              return TicketService.getOrderReceiveList(orderid);

            case 4:
              res = _context8.sent;
              commit('setState', {
                state: 'receiveInfo',
                value: _objectSpread(_objectSpread({}, state.receiveInfo), {}, _defineProperty({}, orderid, res.list || []))
              });
              _context8.next = 11;
              break;

            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8["catch"](1);
              console.error(_context8.t0);

            case 11:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[1, 8]]);
    }))();
  },
  getNow: function getNow(_ref9) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      var commit, time;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref9.commit;
              time = Date.now();
              _context9.prev = 2;
              _context9.next = 5;
              return now();

            case 5:
              time = _context9.sent;
              _context9.next = 11;
              break;

            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](2);
              console.log(_context9.t0);

            case 11:
              commit('setState', {
                state: 'now',
                value: time
              });

            case 12:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[2, 8]]);
    }))();
  },
  getOrderInfo: function getOrderInfo(_ref10, orderid) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit = _ref10.commit;
              _context10.prev = 1;
              _context10.next = 4;
              return TicketService.getOrderInfo(orderid);

            case 4:
              res = _context10.sent;
              commit('setState', {
                state: 'orderInfo',
                value: _objectSpread(_objectSpread({}, state.orderInfo), {}, _defineProperty({}, orderid, res.order))
              });
              _context10.next = 11;
              break;

            case 8:
              _context10.prev = 8;
              _context10.t0 = _context10["catch"](1);
              console.error(_context10.t0);

            case 11:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[1, 8]]);
    }))();
  },
  getTicketInfo: function getTicketInfo(_ref11) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit = _ref11.commit;
              _context11.prev = 1;
              _context11.next = 4;
              return TicketService.getTicketInfo();

            case 4:
              res = _context11.sent;
              commit('setState', {
                state: 'ticketInfo',
                value: res.list
              });
              _context11.next = 11;
              break;

            case 8:
              _context11.prev = 8;
              _context11.t0 = _context11["catch"](1);
              console.error(_context11.t0);

            case 11:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[1, 8]]);
    }))();
  }
};
var getters = {
  selfTicketCount: function selfTicketCount() {
    var list = state.buyList || [];
    var total = 0;
    list.forEach(function (item) {
      total += item.iTicketNum;
    });
    return total;
  },
  isLiveEnd: function isLiveEnd() {
    return true; // const liveEndTime = new Date(window.setting.直播结束时间).getTime()
    // return state.now >= liveEndTime
  }
};
export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});